// extracted by mini-css-extract-plugin
export default {"banners":"t8D68","banner":"nHPwB","slideIn":"fGvXZ"};